import { NgOptimizedImage } from '@angular/common';
import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
  ViewChild,
  inject,
} from '@angular/core';
import {
  RdsCellDefDirective,
  RdsCellDirective,
  RdsColumnDefDirective,
  RdsHeaderCellDefDirective,
  RdsHeaderCellDirective,
  RdsHeaderRowComponent,
  RdsHeaderRowDefDirective,
  RdsIconButtonComponent,
  RdsIconComponent,
  RdsRowComponent,
  RdsRowDefDirective,
  RdsSortDirective,
  RdsSortHeaderComponent,
  RdsTableComponent,
  RdsTableDataSource,
  RdsTooltipDirective,
} from '@rds/angular-components';

import { RoomsModel, ViewportService } from '@bookly/shared';

import { RoomCardComponent } from '../room-card/room-card.component';

@Component({
  selector: 'bad-rooms-list-table',
  imports: [
    NgOptimizedImage,
    RdsTooltipDirective,
    RdsTableComponent,
    RdsSortDirective,
    RdsColumnDefDirective,
    RdsHeaderCellDirective,
    RdsSortHeaderComponent,
    RdsHeaderCellDefDirective,
    RdsCellDefDirective,
    RdsCellDirective,
    RdsIconComponent,
    RdsIconButtonComponent,
    RdsHeaderRowComponent,
    RdsHeaderRowDefDirective,
    RdsRowComponent,
    RdsRowDefDirective,
    RoomCardComponent,
  ],
  templateUrl: './rooms-list-table.component.html',
  styleUrl: './rooms-list-table.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RoomsListTableComponent implements AfterViewInit {
  @Input() public set rooms(value: RoomsModel[] | null) {
    if (value) {
      this.dataSource.data = value;
    }
  }
  @Output() public rowClicked = new EventEmitter<RoomsModel>();

  /** Below 1024px the table is replaced by a stacked card list. */
  protected readonly isCompact = inject(ViewportService).isCompact;

  protected readonly dataSource = new RdsTableDataSource<RoomsModel>([]).init();

  protected readonly displayedColumns: (
    | keyof RoomsModel
    | 'actions'
    | 'multiselect'
    | 'image'
  )[] = ['name', 'image', 'description', 'type', 'capacity'];
  @ViewChild(RdsSortDirective) sort: RdsSortDirective | null = null;

  public ngAfterViewInit(): void {
    this.dataSource.sort = this.sort;
  }

  /** Space activates the card like a button, without scrolling the page. */
  protected onCardSpace(event: Event, rowData: RoomsModel) {
    event.preventDefault();
    this.clickRowHandler(rowData);
  }

  protected clickRowHandler(rowData: RoomsModel) {
    this.rowClicked.emit(rowData);
  }
}
